import React from "react";

import { Icon } from "../../../../Icons/Icon";
import { useCandyTheme } from "../../../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

export enum ErrorItemIconStatus {
    Error = "Error",
    Warning = "Warning",
    Success = "Success",
    Unknown = "Unknown",
}

interface ErrorItemIconProps {
    status: ErrorItemIconStatus;
    isTouched?: boolean;
}

export const ErrorItemIcon = (props: ErrorItemIconProps) => {
    const theme = useCandyTheme();

    const iconConfig = {
        [ErrorItemIconStatus.Unknown]: { color: theme.icons.disabledColor, name: "ShapeCircleSIcon" },
        [ErrorItemIconStatus.Error]: { color: theme.semanticColors.danger.iconColor, name: "XCircleIcon" },
        [ErrorItemIconStatus.Warning]: { color: theme.semanticColors.warning.iconColor, name: "WarningCircleIcon" },
        [ErrorItemIconStatus.Success]: { color: theme.semanticColors.success.iconColor, name: "CheckCircleIcon" },
    };

    const IconProps = iconConfig[props.status] || { color: theme.icons.disabledColor, name: "ShapeCircleSIcon" };

    const color = props.isTouched ? theme.icons.disabledColor : IconProps.color;

    return <Icon color={color} name={IconProps.name} weight="solid" />;
};
